import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router';
import { AccessGate } from './components/AccessGate';
import { Layout } from './components/Layout';
import { Page } from './components/Page';
import { ProjectLayout } from './components/ProjectLayout';
import { Loading, TextLink } from './components/ui';
import { DocsPage } from './docs/DocsPage';
import { Account } from './pages/Account';
import { CliAuthorize } from './pages/CliAuthorize';
import { CliSessions } from './pages/CliSessions';
import { NewProject } from './pages/NewProject';
import { ProjectData } from './pages/ProjectData';
import { ProjectMultiplayer } from './pages/ProjectMultiplayer';
import { ProjectOverview } from './pages/ProjectOverview';
import { ProjectSchedule } from './pages/ProjectSchedule';
import { ProjectScheduleTrash } from './pages/ProjectScheduleTrash';
import { ProjectSettings } from './pages/ProjectSettings';
import { ProjectSubmissions } from './pages/ProjectSubmissions';
import { Projects } from './pages/Projects';
import { ProjectUi } from './pages/ProjectUi';
import { SubmissionDetail } from './pages/SubmissionDetail';

// The store listing's editor (TipTap) loads only when its page opens.
const ProjectListing = lazy(() =>
  import('./pages/ProjectListing').then((page) => ({ default: page.ProjectListing })),
);

function NotFound() {
  return (
    <Page title="Page not found">
      <p>
        <TextLink to="/">Back to your projects</TextLink>
      </p>
    </Page>
  );
}

export function DevRoutes() {
  return (
    <Routes>
      <Route path="cli" element={<CliAuthorize />} />
      {/* The Game UI editor fills the screen, like a page builder; it opens in a new tab. */}
      <Route path="projects/:id/ui" element={<ProjectUi />} />
      <Route element={<Layout />}>
        <Route index element={<Projects />} />
        <Route path="projects/new" element={<NewProject />} />
        {/* A project's tabs share its header (M25). */}
        <Route path="projects/:id" element={<ProjectLayout />}>
          <Route index element={<ProjectOverview />} />
          <Route path="data" element={<ProjectData />} />
          <Route path="multiplayer" element={<ProjectMultiplayer />} />
          <Route path="schedule" element={<ProjectSchedule />} />
          <Route path="schedule/trash" element={<ProjectScheduleTrash />} />
          <Route
            path="listing"
            element={
              <Suspense fallback={<Loading />}>
                <ProjectListing />
              </Suspense>
            }
          />
          <Route path="submissions" element={<ProjectSubmissions />} />
          <Route path="submissions/:submissionId" element={<SubmissionDetail />} />
          <Route path="settings" element={<ProjectSettings />} />
        </Route>
        <Route path="cli/sessions" element={<CliSessions />} />
        <Route path="docs" element={<DocsPage />} />
        <Route path="docs/:slug" element={<DocsPage />} />
        <Route path="account" element={<Account />} />
        <Route path="account/:section" element={<Account />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AccessGate>
        <DevRoutes />
      </AccessGate>
    </BrowserRouter>
  );
}
